/*
 * SPDX-FileCopyrightText: © 2023 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url("../shared.css");

:host {
  display: flex;
  flex-grow: 1;
}

.web,
.mobile {
  --qds-theme-link-standard-default: var(--qds-theme-text-standard);
  --qds-theme-link-standard-hover: var(--qds-theme-text-standard);
  --qds-theme-link-standard-pressed: var(--qds-theme-text-standard);
  --qds-theme-feedback-message-informational: var(--qds-theme-text-standard);
  --qds-theme-interactive-background-hover: var(
    --qds-theme-panel-subsection-standard-background
  );
}

.web {
  background-color: var(--qds-theme-main-background);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(
    --qds-navigation-eyebrow-padding,
    0 var(--qds-block-promo-padding-horizontal)
  );
  flex-grow: 1;
  height: var(
    --qds-navigation-eyebrow-height,
    var(--qds-control-standard-height)
  );
  transform: var(--qds-navigation-eyebrow-transform, translateY(0));
  transition: all 0.5s ease;

  .eyebrow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--qds-control-small-gap-siblings-unrelated);
    max-width: var(--qds-navigation-header-max-width, 1424px);
    width: 100%;
  }

  &.is-scroll {
    height: 0;
    transform: translateY(calc(-1 * var(--qds-control-standard-height)));
  }

  .qds-eyebrow-item-gap {
    display: flex;
    gap: var(--qds-control-small-gap-siblings-unrelated);
  }
}

.mobile {
  background-color: var(--qds-theme-main-background);
  flex-grow: 1;
  padding: var(--qds-block-promo-padding-vertical)
    var(--qds-block-promo-padding-horizontal);

  .eyebrow {
    display: flex;
    flex-direction: column;
    gap: var(--qds-control-small-gap-siblings-related);
  }

  .qds-eyebrow-item-gap {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--qds-control-small-gap-siblings-related);
  }
}
